import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Heading/Heading';

class Heading extends React.Component {
  render() {
    let section = this.props.section;
    return (
      <div className="fus-section-header">
        <InlineEditableElement
          el="h1"
          fontFamilyChanged={this.props.fontFamilyChanged}
          {...this.props.inlineEditorProps}
          html={section.prop('title')}
          onChange={this.props.titleChanged.bind(this)}
          inlineEditingEnabled={this.props.inlineEditingEnabled}
        />
        {typeof section.prop('subtitle') !== 'undefined' ||
        this.props.inlineEditingEnabled ? (
          <InlineEditableElement
            fontFamilyChanged={this.props.fontFamilyChanged}
            el="h4"
            {...this.props.inlineEditorProps}
            html={section.prop('subtitle')}
            onChange={this.props.subtitleChanged.bind(this)}
            inlineEditingEnabled={this.props.inlineEditingEnabled}
          />
        ) : null}
      </div>
    );
  }
}

export default hoc(Heading);
